module.exports = __webpack_public_path__ + "07fc40dda7f809fd6bd99a5a8873fbcc.pdf";